import RestoreIcon from '@mui/icons-material/Restore';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import { Box, IconButton } from '@mui/material';
import React from 'react';

interface MultiMapControlsProps {
  fullscreen: boolean;
  onToggleFullscreen: () => void;
  onResetMap: () => void;
}

const MultiMapControls: React.FC<MultiMapControlsProps> = ({
  fullscreen,
  onToggleFullscreen,
  onResetMap,
}) => (
  <Box
    sx={{
      position: 'absolute',
      top: 8,
      right: 8,
      display: 'flex',
      gap: 1,
      zIndex: 10,
    }}
  >
    <IconButton
      onClick={onToggleFullscreen}
      aria-label={fullscreen ? 'Minimize map' : 'Maximize map'}
      sx={{
        backgroundColor: 'white',
        boxShadow: 2,
      }}
    >
      {fullscreen ? <ZoomOutIcon /> : <ZoomInIcon />}
    </IconButton>
    <IconButton
      onClick={onResetMap}
      aria-label="Reset map"
      sx={{
        backgroundColor: 'white',
        boxShadow: 2,
      }}
    >
      <RestoreIcon />
    </IconButton>
  </Box>
);

export default MultiMapControls;
